/* Samba Street Co Website V2 — lightweight, accessible interactions */
(()=>{
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header=document.querySelector('.header-wrapper');
  let ticking=false;
  const syncHeader=()=>{
    header?.classList.toggle('samba-header--scrolled',scrollY>12);
    ticking=false;
  };
  const onScroll=()=>{
    if(ticking)return;
    ticking=true;
    requestAnimationFrame(syncHeader);
  };
  syncHeader();
  addEventListener('scroll',onScroll,{passive:true});

  if(reduced||!('IntersectionObserver'in window))return;
  const items=[...document.querySelectorAll(
    '.template-index .samba-home__block, .template-index .samba-home__benefits, .template-index .samba-home__community, .template-index .samba-home__manifesto'
  )];
  items.forEach(item=>item.classList.add('samba-reveal'));
  const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      entry.target.classList.add('samba-reveal--visible');
      observer.unobserve(entry.target);
    });
  },{rootMargin:'0px 0px -7% 0px',threshold:.05});
  items.forEach(item=>observer.observe(item));
})();

/* Phase 2 — conversion foundations */
(()=>{
  const productInfo=document.querySelector('.template-product .product__info-container');
  if(productInfo&&!productInfo.querySelector('.samba-pdp-trust')){
    const trust=document.createElement('div');
    trust.className='samba-pdp-trust';
    trust.setAttribute('aria-label','Ordering information');
    trust.innerHTML='<article><span class="samba-pdp-trust__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/></svg></span><span class="samba-pdp-trust__copy"><small>Delivery</small><strong>Clear timing</strong><em>Please allow up to 21 business days</em></span></article><article><span class="samba-pdp-trust__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c3 3 4 6 4 9s-1 6-4 9c-3-3-4-6-4-9s1-6 4-9Z"/></svg></span><span class="samba-pdp-trust__copy"><small>From Perth</small><strong>Worldwide delivery</strong><em>Connecting football fans everywhere</em></span></article><article><span class="samba-pdp-trust__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m5 11 7-7 7 7v8H5z"/><path d="M9 14h6M9 17h4"/></svg></span><span class="samba-pdp-trust__copy"><small>Shop with confidence</small><strong>Secure checkout</strong><em>Trusted payment options at checkout</em></span></article>';
    const form=productInfo.querySelector('product-form,.product-form');
    (form?.parentNode||productInfo).insertBefore(trust,form?.nextSibling||null);
    if(!productInfo.querySelector('.samba-pdp-info')){
      const info=document.createElement('div');
      info.className='samba-pdp-info';
      info.setAttribute('aria-label','Delivery, care and returns information');
      info.innerHTML='<details><summary><span><small>01</small><strong>Delivery</strong></span><b aria-hidden="true">+</b></summary><div><p>Please allow up to <strong>21 business days</strong> for delivery. We ship worldwide from Perth, and timing may vary by destination.</p><a href="/pages/contact">Questions about your order? Contact us →</a></div></details><details><summary><span><small>02</small><strong>Jersey care</strong></span><b aria-hidden="true">+</b></summary><div><p>Wash cold and inside out with similar colours. Use a gentle cycle, avoid bleach and fabric softener, and air dry. Do not tumble dry or iron directly over badges, names or numbers.</p></div></details><details><summary><span><small>03</small><strong>Returns</strong></span><b aria-hidden="true">+</b></summary><div><p>Eligible items may be returned within 30 days of receipt when unworn, unused, with tags and in the original packaging. Personalised products, sale items and gift cards are not returnable.</p><a href="/policies/refund-policy">Read the full refund policy →</a></div></details>';
      trust.parentNode.insertBefore(info,trust.nextSibling);
    }
    const isKidsProduct=/\/products\/[^/?]+-kids(?:[/?]|$)/.test(location.pathname);
    if(!productInfo.querySelector('.samba-fit-guide')){
      const fit=document.createElement('details');
      fit.className='samba-fit-guide';
      if(isKidsProduct){
        fit.innerHTML='<summary><span><small>Need help choosing?</small><strong>Kids size & fit guide</strong></span><em>View guide <b aria-hidden="true">+</b></em></summary><div class="samba-fit-guide__body"><div class="samba-fit-guide__compare"><article><small>Kids kit fit</small><strong>Comfort made for movement</strong><p>A comfortable everyday cut designed for playing, match days and casual wear.</p></article><article><small>Complete set</small><strong>Shirt + matching shorts</strong><p>Each Kids kit includes both pieces. Use the chart measurements to choose one size for the complete set.</p></article></div><p class="samba-fit-guide__note"><strong>Choosing a size:</strong> Compare the chart with a kit your child already wears. If your child is between sizes, choose the larger size for comfort and longer wear.</p><img src="https://cdn.shopify.com/s/files/1/0942/0193/8104/files/samba-kids-size-guide.png?v=1787413298" alt="Samba Street Co Kids kit size guide with age, height, shirt and shorts measurements in centimetres" width="1536" height="1024" loading="lazy"></div>';
      }else{
        fit.innerHTML='<summary><span><small>Need help choosing?</small><strong>Size & fit guide</strong></span><em>View guide <b aria-hidden="true">+</b></em></summary><div class="samba-fit-guide__body"><div class="samba-fit-guide__compare"><article><small>Fan version</small><strong>Relaxed everyday fit</strong><p>Regular cut with more room through the chest and sleeves. Durable construction and raised embroidered badges.</p></article><article><small>Player version</small><strong>Slim athletic fit</strong><p>Lightweight performance construction with ventilation and heat-applied details. Size up for a more relaxed fit.</p></article></div><p class="samba-fit-guide__note"><strong>Supplier sizing:</strong> These labels do not follow a universal Australian standard. Measure a jersey you already own and compare it with the garment measurements.</p><img src="https://cdn.shopify.com/s/files/1/0942/0193/8104/files/samba-size-guide-v1.png?v=1787330548" alt="Samba Street Co fan, player and women’s jersey size guide in centimetres" width="1024" height="1536" loading="lazy"></div>';
      }
      (form?.parentNode||productInfo).insertBefore(fit,form||null);
    }
    if(isKidsProduct){
      const removeKidsSizingHint=()=>{
        document.querySelectorAll('.po-field-helpText').forEach(node=>{
          if(node.textContent.trim()==='Not sure about sizing? View our Kids Size Guide above.') node.remove();
        });
      };
      removeKidsSizingHint();
      const kidsHintObserver=new MutationObserver(removeKidsSizingHint);
      kidsHintObserver.observe(productInfo,{childList:true,subtree:true});
      window.setTimeout(()=>kidsHintObserver.disconnect(),10000);
    }
  }

  const collectionMain=document.querySelector('.template-collection main, .template-collection #MainContent');
  const facets=collectionMain?.querySelector('facet-filters-form,.facets-container');
  if(collectionMain&&facets&&!collectionMain.querySelector('.samba-jersey-search')){
    const search=document.createElement('form');
    search.className='samba-jersey-search page-width';
    search.method='get';
    search.action='/search';
    search.setAttribute('role','search');
    search.innerHTML='<div class="samba-jersey-search__main"><label for="SambaJerseySearch"><span>Find your shirt</span><strong>Search by club, nation, player or era</strong></label><div class="samba-jersey-search__field"><input id="SambaJerseySearch" type="search" name="q" placeholder="e.g. Rossoneri, Socceroos, Ronaldinho" autocomplete="off" aria-autocomplete="list" aria-controls="SambaJerseySuggestions" aria-expanded="false"><input type="hidden" name="type" value="product"><button type="submit">Search <span aria-hidden="true">→</span></button><div class="samba-jersey-search__suggestions" id="SambaJerseySuggestions" role="listbox" hidden></div></div></div><nav class="samba-jersey-search__shortcuts" aria-label="Popular shirt categories"><span>Explore:</span><a href="/search?q=2026%2F27&type=product">New 2026/27</a><a href="/collections/fifa-world-cup-2026">National teams</a><a href="/collections/retros">Retro</a><a href="/collections/special-editons">Special editions</a><a href="/collections/premier-league">Premier League</a></nav>';
    facets.parentNode.insertBefore(search,facets);

    const input=search.querySelector('#SambaJerseySearch');
    const suggestions=search.querySelector('#SambaJerseySuggestions');
    const indexNode=document.querySelector('#SambaPilotSearchIndex');
    let pilotProducts=[];
    try{pilotProducts=JSON.parse(indexNode?.textContent||'[]').filter(product=>product?.title&&product?.url);}catch(error){pilotProducts=[];}
    const normalise=value=>(value||'').toString().normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
    const closeSuggestions=()=>{
      suggestions.hidden=true;
      suggestions.innerHTML='';
      input.setAttribute('aria-expanded','false');
    };
    const renderSuggestions=()=>{
      const query=normalise(input.value);
      if(query.length<2||!pilotProducts.length){closeSuggestions();return;}
      const matches=pilotProducts.map(product=>{
        const aliases=Array.isArray(product.aliases)?product.aliases:[];
        const primary=[product.title,product.team,...aliases].map(normalise);
        const secondary=[product.country,product.season,product.style,product.era,product.edition].map(normalise);
        let score=0;
        primary.forEach(value=>{if(value===query)score+=100;else if(value.startsWith(query))score+=60;else if(value.includes(query))score+=35;});
        secondary.forEach(value=>{if(value===query)score+=45;else if(value.includes(query))score+=20;});
        return {product,score};
      }).filter(match=>match.score>0).sort((a,b)=>b.score-a.score).slice(0,4);
      if(!matches.length){closeSuggestions();return;}
      suggestions.innerHTML='<div class="samba-jersey-search__suggestion-label">Suggested shirts</div>'+matches.map(({product})=>{
        const meta=[product.team,product.season,product.style].filter(Boolean).join(' · ');
        return '<a role="option" href="'+product.url+'"><img src="'+product.image+'" alt="" width="64" height="64" loading="lazy"><span><strong>'+product.title+'</strong><small>'+meta+'</small></span><em>'+product.price+' <b aria-hidden="true">→</b></em></a>';
      }).join('');
      suggestions.hidden=false;
      input.setAttribute('aria-expanded','true');
    };
    input.addEventListener('input',renderSuggestions);
    input.addEventListener('focus',renderSuggestions);
    input.addEventListener('keydown',event=>{if(event.key==='Escape')closeSuggestions();});
    document.addEventListener('click',event=>{if(!search.contains(event.target))closeSuggestions();});
  }
})();

/* Phase 2 — Personalisation UX */
(()=>{
  if(!document.body.classList.contains('template-product'))return;
  const enhance=()=>{
    const hidden=document.querySelector('input[name="properties[Customize Name And Number]"]');
    const liveToggle=document.querySelector('button[class*="po-toggle"]');
    const root=hidden?.closest('.po-field-root')||liveToggle?.closest('.po-field-root');
    if(!root)return;
    root.classList.add('samba-personalise');
    const toggle=root.querySelector('button[class*="po-toggle"]');
    const active=toggle?.className.toString().includes('po-toggle-on');
    if(toggle){
      toggle.type='button';
      toggle.setAttribute('aria-label','Toggle name and number personalisation');
      toggle.setAttribute('aria-pressed',active?'true':'false');
    }
    root.classList.toggle('samba-personalise--active',!!active);
    const switchRow=root.querySelector('.po-switch-root');
    let status=root.querySelector('.samba-personalise__status');
    if(!status&&switchRow){
      status=document.createElement('span');
      status.className='samba-personalise__status';
      switchRow.appendChild(status);
    }
    if(status)status.textContent=active?'Selected':'Not selected';
    const input=root.parentElement?.querySelector('input[type="text"]')||document.querySelector('input[placeholder="Neymar Jr 10"]');
    if(input){
      input.maxLength=24;
      input.placeholder='e.g. RONALDO 7';
      input.setAttribute('aria-label','Name and number exactly as it should appear');
      const fieldRoot=input.closest('.po-textField-root')?.parentElement;
      if(fieldRoot&&!fieldRoot.querySelector('.samba-personalise__input-help')){
        const help=document.createElement('p');
        help.className='samba-personalise__input-help';
        help.innerHTML='<strong>Enter name + number together.</strong> Double-check spelling before adding to cart. Personalised items cannot be exchanged for typing errors.';
        fieldRoot.appendChild(help);
      }
    }
  };
  let attempts=0;
  const waitForOptions=setInterval(()=>{
    attempts+=1;
    enhance();
    if(document.querySelector('.samba-personalise')||attempts>=50)clearInterval(waitForOptions);
  },100);
  document.addEventListener('click',event=>{
    if(!event.target.closest('button[class*="po-toggle"]'))return;
    [100,350,800].forEach(delay=>setTimeout(enhance,delay));
  },true);
})();

/* Phase 2 — Mobile sticky Add to Cart */
(()=>{
  if(!document.body.classList.contains('template-product'))return;
  const setup=()=>{
    if(document.querySelector('.samba-sticky-atc'))return true;
    const original=document.querySelector('.product-form__submit[name="add"],.product-form__submit');
    const title=document.querySelector('.product__title h1');
    const price=document.querySelector('.product__info-container .price .price-item--regular,.product__info-container .price-item--regular');
    if(!original||!title)return false;
    const bar=document.createElement('aside');
    bar.className='samba-sticky-atc';
    bar.setAttribute('aria-label','Quick add to cart');
    bar.innerHTML='<div class="samba-sticky-atc__product"><strong></strong><span></span></div><button type="button"><span>Add to cart</span><b aria-hidden="true">→</b></button>';
    bar.querySelector('strong').textContent=title.textContent.trim();
    bar.querySelector('.samba-sticky-atc__product span').textContent=price?.textContent.trim()||'';
    const button=bar.querySelector('button');
    const sync=()=>{
      button.disabled=original.disabled;
      button.querySelector('span').textContent=original.querySelector('span')?.textContent.trim()||original.textContent.trim()||'Add to cart';
      const currentPrice=document.querySelector('.product__info-container .price .price-item--regular,.product__info-container .price-item--regular');
      if(currentPrice)bar.querySelector('.samba-sticky-atc__product span').textContent=currentPrice.textContent.trim();
    };
    sync();
    button.addEventListener('click',()=>original.click());
    document.body.appendChild(bar);
    const visibility=()=>{
      const rect=original.getBoundingClientRect();
      const show=scrollY>240&&(rect.bottom<0||rect.top>innerHeight);
      document.body.classList.toggle('samba-sticky-atc-visible',show);
    };
    const observer=new IntersectionObserver(visibility,{threshold:.05});
    observer.observe(original);
    addEventListener('scroll',visibility,{passive:true});
    addEventListener('resize',visibility,{passive:true});
    new MutationObserver(sync).observe(original,{attributes:true,childList:true,subtree:true});
    visibility();
    return true;
  };
  let attempts=0;
  const timer=setInterval(()=>{attempts+=1;if(setup()||attempts>=40)clearInterval(timer)},100);
})();

/* Phase 2 — Contextual club recommendations */
(()=>{
  if(!document.body.classList.contains('template-product'))return;
  const section=document.querySelector('product-recommendations');
  const currentTitle=document.querySelector('.product__title h1')?.textContent.trim();
  if(!section||!currentTitle)return;
  const club=currentTitle
    .replace(/\s+(?:FIFA\s+World\s+Cup|(?:19|20)\d{2}|\d{2}\/\d{2}|\d{2}(?:th|st|nd|rd)\s+Anniversary|Retro|Home|Away|Third|Special\s+Edition).*$/i,'')
    .trim();
  if(club.length<3)return;
  const load=async()=>{
    try{
      const response=await fetch('/search?q='+encodeURIComponent(club)+'&type=product',{headers:{'X-Requested-With':'XMLHttpRequest'}});
      if(!response.ok)return;
      const html=await response.text();
      const doc=new DOMParser().parseFromString(html,'text/html');
      const currentPath=location.pathname.replace(/\/$/,'');
      const candidates=[...doc.querySelectorAll('.product-grid .grid__item')].filter(card=>{
        const link=card.querySelector('.card__heading a');
        if(!link)return false;
        const title=link.textContent.trim().toLowerCase();
        const path=new URL(link.href,location.origin).pathname.replace(/\/$/,'');
        return path!==currentPath&&title.includes(club.toLowerCase());
      }).slice(0,3);
      if(!candidates.length)return;
      const list=document.createElement('ul');
      list.className='grid product-grid samba-club-recommendations';
      list.setAttribute('role','list');
      candidates.forEach(card=>list.appendChild(card.cloneNode(true)));
      section.innerHTML='';
      const eyebrow=document.createElement('p');
      eyebrow.className='samba-club-recommendations__eyebrow';
      eyebrow.textContent='Stay with the colours';
      const heading=document.createElement('h2');
      heading.className='related-products__heading inline-richtext h2';
      heading.textContent='More from '+club;
      section.append(eyebrow,heading,list);
      section.classList.add('samba-club-recommendations--ready','samba-club-recommendations--count-'+candidates.length);
    }catch(error){}
  };
  const observer=new IntersectionObserver(entries=>{
    if(!entries.some(entry=>entry.isIntersecting))return;
    observer.disconnect();
    load();
  },{rootMargin:'500px 0px',threshold:0});
  observer.observe(section);
})();
/* Samba Filter Drawer V1 */
(()=>{
  if(!document.body.classList.contains('template-collection'))return;
  let scheduled=false;
  const priority=['Team type','Team','Shirt style','Era','Edition','Competition','Season','Country','Version','Availability','Price'];
  const enhance=()=>{
    scheduled=false;
    const wrapper=document.querySelector('.facets-container-drawer .mobile-facets__wrapper');
    const form=wrapper?.querySelector('#FacetFiltersFormMobile');
    const main=form?.querySelector('#FacetsWrapperMobile');
    if(!wrapper||!form||!main)return;

    wrapper.classList.add('samba-filter-drawer');
    wrapper.querySelectorAll('.mobile-facets__open-label').forEach(label=>{
      label.textContent=window.matchMedia('(max-width:749px)').matches?'Filter & sort':'Filter jerseys';
    });

    let badge=wrapper.querySelector('.samba-filter-count');
    if(!badge){
      badge=document.createElement('span');
      badge.className='samba-filter-count';
      wrapper.querySelector('.mobile-facets__open')?.appendChild(badge);
    }
    const selected=new URLSearchParams(location.search);
    const activeKeys=new Set();
    selected.forEach((value,key)=>{if(key.startsWith('filter.')&&value.trim()!=='')activeKeys.add(key+'='+value);});
    badge.textContent=activeKeys.size;
    badge.hidden=activeKeys.size===0;

    const details=Array.from(main.children).filter(node=>node.matches?.('details.mobile-facets__details'));
    const ordered=[...details].sort((a,b)=>{
      const aLabel=a.querySelector('.mobile-facets__summary span')?.textContent.trim()||'';
      const bLabel=b.querySelector('.mobile-facets__summary span')?.textContent.trim()||'';
      const ai=priority.indexOf(aLabel),bi=priority.indexOf(bLabel);
      return (ai<0?99:ai)-(bi<0?99:bi);
    });
    if(details.some((item,index)=>item!==ordered[index])){
      const anchor=Array.from(main.children).find(node=>!node.matches?.('details.mobile-facets__details'));
      ordered.forEach(item=>main.insertBefore(item,anchor||null));
    }

    ordered.forEach(detail=>{
      const label=detail.querySelector('.mobile-facets__summary span')?.textContent.trim();
      if(!['Team','Country'].includes(label)||detail.querySelector('.samba-facet-search'))return;
      const list=detail.querySelector('.mobile-facets__list');
      if(!list)return;
      const search=document.createElement('div');
      search.className='samba-facet-search';
      const input=document.createElement('input');
      input.type='search';
      input.placeholder='Search '+label.toLowerCase();
      input.setAttribute('aria-label','Search '+label.toLowerCase()+' filter values');
      input.autocomplete='off';
      input.addEventListener('input',()=>{
        const query=input.value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
        list.querySelectorAll('.mobile-facets__item').forEach(item=>{
          const text=item.textContent.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
          item.hidden=query.length>0&&!text.includes(query);
        });
      });
      search.appendChild(input);
      list.parentNode.insertBefore(search,list);
    });
  };
  const schedule=()=>{
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(enhance);
  };
  schedule();
  document.addEventListener('change',event=>{if(event.target.closest('#FacetFiltersFormMobile'))setTimeout(schedule,80);});
  window.addEventListener('popstate',schedule);
  const root=document.querySelector('#main-collection-filters');
  if(root)new MutationObserver(schedule).observe(root,{childList:true,subtree:true});
})();


/* Free Samba option charges v3 — Player upgrade and personalisation */
(()=>{
  if(window.__SAMBA_NATIVE_PRICING_V2__)return;
  const PERSONALISATION_VARIANT_ID='53968956457144';
  const PLAYER_VARIANT_ID='53969006624952';
  const ADDON_PRICE_CENTS=1000;
  if(!document.body.classList.contains('template-product'))return;

  const optionRoot=()=>{
    const roots=[...document.querySelectorAll('.easify-product-options,#easify-product-options')];
    return roots.find(root=>root.querySelector('input,textarea,button[role="switch"],[role="switch"]'))||
      roots.find(root=>root.children.length>0)||roots[0]||null;
  };
  const fieldContext=control=>control?.closest('.po-field,.po-switch,[class*="option"],[class*="field"]')||control?.parentElement;
  const controlText=control=>{
    const own=[control?.value,control?.getAttribute?.('aria-label'),control?.textContent].filter(Boolean).join(' ');
    const id=control?.id;
    const linked=id?document.querySelector('label[for="'+CSS.escape(id)+'"]')?.textContent:'';
    return (own+' '+(linked||'')+' '+(fieldContext(control)?.textContent||'')).trim();
  };
  const isControlSelected=control=>Boolean(control&&(control.checked||control.getAttribute('aria-checked')==='true'||control.getAttribute('aria-pressed')==='true'||control.classList.contains('active')||control.closest('.active,.checked,[data-checked="true"]')));
  const customiseToggle=()=>{
    const root=optionRoot();
    if(!root)return null;
    const controls=[...root.querySelectorAll('input[type="checkbox"],button[role="switch"],[role="switch"]')];
    return controls.find(control=>/customi[sz]e name|name.*number/i.test(controlText(control)))||controls[0]||null;
  };
  const personalisationText=()=>{
    const root=optionRoot();
    if(!root)return '';
    const fields=[...root.querySelectorAll('input[type="text"],textarea')];
    const field=fields.find(input=>/name and number|name \+ number|nome e numero/i.test(fieldContext(input)?.textContent||''))||
      fields.find(input=>/neymar|name.*number/i.test(input.placeholder||''));
    return field?.value?.trim()||'';
  };
  const personalisationSelected=()=>{
    const control=customiseToggle();
    return isControlSelected(control)||personalisationText().length>0;
  };
  const playerSelected=()=>{
    const root=optionRoot();
    if(!root)return false;
    const controls=[...root.querySelectorAll('input[type="radio"],input[type="checkbox"],button,[role="radio"],[role="option"]')];
    return controls.some(control=>isControlSelected(control)&&/(^|\s|\/)player(?:\s|$|\/)/i.test(controlText(control)));
  };
  const basePriceCents=()=>{
    const configPrice=Number(window.TPOConfigs?.selected_variant?.price);
    if(Number.isFinite(configPrice)&&configPrice>0)return configPrice;
    const analyticsPrice=Number(window.ShopifyAnalytics?.meta?.product?.variants?.[0]?.price);
    if(Number.isFinite(analyticsPrice)&&analyticsPrice>0)return analyticsPrice;
    const text=document.querySelector('.product__info-container .price-item--regular,.product__info-container .price-item--sale')?.textContent||'';
    const value=Number(text.replace(/[^0-9.]/g,''));
    return Number.isFinite(value)?Math.round(value*100):0;
  };
  const style=document.createElement('style');
  style.textContent='.samba-configuration{border:0;margin:0 0 1.6rem;padding:0}.samba-configuration legend{font-weight:700;margin-bottom:.45rem}.samba-configuration__hint{font-size:.85rem;line-height:1.35;margin:.2rem 0 .8rem}.samba-configuration__choices{display:grid;gap:.5rem}.samba-configuration__choice{align-items:center;background:#fff;border:1px solid rgba(18,18,18,.2);color:#121212;cursor:pointer;display:flex;justify-content:space-between;padding:.8rem 1rem;text-align:left}.samba-configuration__choice[aria-pressed="true"]{border:2px solid #121212;padding:calc(.8rem - 1px) calc(1rem - 1px)}.samba-configuration__choice strong{font-size:.95rem}.samba-configuration__choice span{font-size:.88rem}.samba-configuration__error{color:#b00020;font-size:.9rem;margin:.65rem 0 0}';
  document.head.appendChild(style);
  const money=cents=>new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(cents/100);
  const decorate=()=>{
    const root=optionRoot();
    if(!root)return;
    root.querySelectorAll('.po-switch-label,label,[class*="label"]').forEach(label=>{
      const clean=(label.childNodes[0]?.textContent||label.textContent||'').trim();
      const isPersonalisation=/customi[sz]e name/i.test(clean);
      const isPlayer=/^player(?:\s+version)?$/i.test(clean);
      if((!isPersonalisation&&!isPlayer)||label.querySelector('.samba-personalisation-price'))return;
      const price=document.createElement('span');
      price.className='samba-personalisation-price';
      price.textContent='+$10 AUD';
      label.appendChild(price);
    });
    root.querySelectorAll('.po-field').forEach(field=>{
      if(!field.querySelector('input[type="text"],textarea')||!/add your name and number|name \+ number/i.test(field.textContent||''))return;
      field.querySelectorAll('.samba-personalisation-price,.po-price,.po-additional-price,[class*="additional-price"]').forEach(price=>{
        if(price.classList.contains('samba-options-total'))return;
        if(/\+?\s*\$?10(?:\.00)?\s*(?:AUD)?/i.test(price.textContent||''))price.remove();
      });
    });
    let total=root.querySelector('.samba-options-total');
    if(!total){
      total=document.createElement('div');
      total.className='samba-options-total samba-personalisation-total';
      root.appendChild(total);
    }
    const player=playerSelected();
    const personalisation=personalisationSelected();
    const extras=(player?ADDON_PRICE_CENTS:0)+(personalisation?ADDON_PRICE_CENTS:0);
    total.hidden=extras===0;
    if(extras){
      const lines=[];
      if(player)lines.push('<span>Player upgrade <b>+$10 AUD</b></span>');
      if(personalisation)lines.push('<span>Personalisation <b>+$10 AUD</b></span>');
      total.innerHTML='<div>'+lines.join('')+'</div><strong>New total: '+money(basePriceCents()+extras)+'</strong>';
    }
  };
  const scheduleDecorate=()=>window.setTimeout(decorate,0);
  decorate();
  const rootObserver=new MutationObserver(scheduleDecorate);
  rootObserver.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('change',scheduleDecorate,true);
  document.addEventListener('input',scheduleDecorate,true);
  document.addEventListener('click',scheduleDecorate,true);
  window.setTimeout(()=>rootObserver.disconnect(),20000);

  const optionState=(body,properties={})=>{
    let personalisation=personalisationSelected();
    let player=playerSelected();
    let entered=personalisationText();
    const inspect=(key,value)=>{
      const pair=String(key)+' '+String(value);
      if(value!==''&&/name.*number|customi[sz]e|nome.*numero/i.test(pair)){
        personalisation=true;
        if(!entered&&!/^(true|yes|on)$/i.test(String(value)))entered=String(value).trim();
      }
      if(/fabric|version|type/i.test(String(key))&&/^player(?:\s+version)?$/i.test(String(value).trim()))player=true;
    };
    if(body instanceof FormData){
      for(const [key,value] of body.entries()){
        const match=key.match(/^properties\[(.+)\]$/);
        if(!match||value==='')continue;
        properties[match[1]]=String(value);
        inspect(match[1],value);
      }
    }else if(properties&&typeof properties==='object'){
      Object.entries(properties).forEach(([key,value])=>inspect(key,value));
    }
    return {personalisation,player,entered,properties};
  };
  const addonItems=(state,quantity)=>{
    const title=document.querySelector('h1')?.textContent?.trim()||'Football shirt';
    const items=[];
    if(state.player)items.push({id:Number(PLAYER_VARIANT_ID),quantity,properties:{'_For product':title,'Upgrade':'Player Version'}});
    if(state.personalisation)items.push({id:Number(PERSONALISATION_VARIANT_ID),quantity,properties:{'_For product':title,'Name + Number':state.entered||'As entered above'}});
    return items;
  };

  const nativeFetch=window.fetch.bind(window);
  window.fetch=async(input,init={})=>{
    const url=typeof input==='string'?input:input?.url||'';
    if(!/\/cart\/add(?:\.js)?(?:\?|$)/.test(url))return nativeFetch(input,init);
    const body=init.body;

    if(body instanceof FormData){
      const mainId=String(body.get('id')||'');
      if(!mainId||[PERSONALISATION_VARIANT_ID,PLAYER_VARIANT_ID].includes(mainId))return nativeFetch(input,init);
      const state=optionState(body,{});
      const quantity=Math.max(1,parseInt(body.get('quantity')||'1',10)||1);
      const extras=addonItems(state,quantity);
      if(extras.length===0)return nativeFetch(input,init);
      if(state.entered&&!Object.values(state.properties).includes(state.entered))state.properties['Name + Number']=state.entered;
      const payload={items:[{id:Number(mainId),quantity,properties:state.properties},...extras]};
      const sections=body.get('sections');
      const sectionsUrl=body.get('sections_url');
      if(sections)payload.sections=String(sections);
      if(sectionsUrl)payload.sections_url=String(sectionsUrl);
      const headers=new Headers(init.headers||{});
      headers.set('Content-Type','application/json');
      return nativeFetch(input,{...init,headers,body:JSON.stringify(payload)});
    }

    if(typeof body==='string'){
      try{
        const payload=JSON.parse(body);
        const items=Array.isArray(payload.items)?payload.items:null;
        const mainItem=items?.find(item=>![PERSONALISATION_VARIANT_ID,PLAYER_VARIANT_ID].includes(String(item.id)))||(payload.id?payload:null);
        if(mainItem&&![PERSONALISATION_VARIANT_ID,PLAYER_VARIANT_ID].includes(String(mainItem.id))){
          const state=optionState(null,mainItem.properties||{});
          const quantity=Math.max(1,Number(mainItem.quantity)||1);
          const existing=new Set((items||[]).map(item=>String(item.id)));
          const extras=addonItems(state,quantity).filter(item=>!existing.has(String(item.id)));
          if(extras.length===0)return nativeFetch(input,init);
          if(items)payload.items.push(...extras);
          else{
            payload.items=[{id:Number(mainItem.id),quantity,properties:mainItem.properties||{}},...extras];
            delete payload.id;
            delete payload.quantity;
            delete payload.properties;
          }
          return nativeFetch(input,{...init,headers:{...(init.headers||{}),'Content-Type':'application/json'},body:JSON.stringify(payload)});
        }
      }catch(error){}
    }
    return nativeFetch(input,init);
  };

  if(['/products/name-number-personalisation','/products/player-version-upgrade'].includes(location.pathname))location.replace('/');
})();


/* Pilot — native-priced configuration for Valencia CF 2026/27 Away.
   Scoped to this product and to the unpublished development theme. */
(()=>{
  if(!document.body.classList.contains('template-product')) return;
  if(location.pathname.replace(/\/$/,'')!=='/products/valencia-cf-2026-27-away') return;
  if(window.__sambaValenciaPilotLoaded) return;
  window.__sambaValenciaPilotLoaded=true;

  const money=cents=>new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(cents/100)+' AUD';
  const getPersonalisation=()=>{
    const root=document.querySelector('.po-field-root');
    const toggle=root?.querySelector('button[class*="po-toggle"]');
    const input=root?.parentElement?.querySelector('input[type="text"]');
    return {root,toggle,input,active:!!toggle?.className.includes('po-toggle-on')};
  };
  const ensurePersonalisation=required=>{
    const option=getPersonalisation();
    if(required&&!option.active) option.toggle?.click();
    if(!required&&option.active) option.toggle?.click();
  };

  const initialise=async()=>{
    const form=document.querySelector('form[action^="/cart/add"]');
    const anchor=document.querySelector('.po-field-root');
    if(!form||!anchor||document.querySelector('.samba-configuration')) return;
    let product;
    try {
      const response=await fetch('/products/valencia-cf-2026-27-away.js');
      if(!response.ok) return;
      product=await response.json();
    } catch(error) { return; }

    const configurations=product.variants.filter(variant=>variant.options?.[0]);
    if(configurations.length!==4) return;
    const box=document.createElement('fieldset');
    box.className='samba-configuration';
    box.innerHTML='<legend>Choose your configuration</legend><p class="samba-configuration__hint">Pricing is part of the shirt variant and cannot be removed separately at checkout.</p><div class="samba-configuration__choices"></div><p class="samba-configuration__error" role="alert" hidden></p>';
    const choices=box.querySelector('.samba-configuration__choices');
    const variantId=()=>Number(form.querySelector('.product-variant-id')?.value);
    let selected=configurations.find(variant=>variant.id===variantId())||configurations[0];

    const render=()=>{
      choices.innerHTML='';
      configurations.forEach(variant=>{
        const button=document.createElement('button');
        button.type='button';
        button.className='samba-configuration__choice';
        button.setAttribute('aria-pressed',String(variant.id===selected.id));
        button.innerHTML='<strong>'+variant.options[0]+'</strong><span>'+money(variant.price)+'</span>';
        button.addEventListener('click',()=>select(variant));
        choices.appendChild(button);
      });
    };
    const syncPrice=variant=>{
      document.querySelectorAll('.product__info-container .price-item--regular').forEach(node=>{node.textContent=money(variant.price);});
      document.querySelectorAll('.samba-sticky-atc__product span').forEach(node=>{node.textContent=money(variant.price);});
    };
    const select=variant=>{
      selected=variant;
      document.querySelectorAll('form[action^="/cart/add"] .product-variant-id').forEach(input=>{
        input.value=String(variant.id);
        input.dispatchEvent(new Event('change',{bubbles:true}));
      });
      ensurePersonalisation(variant.options[0].includes('Personalisation'));
      syncPrice(variant);
      box.querySelector('.samba-configuration__error').hidden=true;
      render();
    };

    anchor.parentNode.insertBefore(box,anchor);
    render();
    select(selected);

    document.addEventListener('click',event=>{
      if(!event.target.closest('.po-field-root button[class*="po-toggle"]')) return;
      window.setTimeout(()=>{
        const option=getPersonalisation();
        if(option.active&&!selected.options[0].includes('Personalisation')){
          const player=selected.options[0].includes('Player');
          select(configurations.find(variant=>variant.options[0]===(player?'Player + Personalisation':'Fan + Personalisation')));
        }
      },0);
    },true);

    form.addEventListener('submit',event=>{
      const option=getPersonalisation();
      const hasText=Boolean(option.input?.value.trim());
      const personalisationChosen=option.active||hasText;
      if(personalisationChosen&&!selected.options[0].includes('Personalisation')){
        const player=selected.options[0].includes('Player');
        select(configurations.find(variant=>variant.options[0]===(player?'Player + Personalisation':'Fan + Personalisation')));
      }
      if(selected.options[0].includes('Personalisation')&&!hasText){
        event.preventDefault();
        const error=box.querySelector('.samba-configuration__error');
        error.textContent='Enter the name and number for this personalised shirt before adding it to cart.';
        error.hidden=false;
        option.input?.focus();
      }
    },true);
  };

  let attempts=0;
  const timer=setInterval(()=>{
    attempts+=1;
    initialise();
    if(document.querySelector('.samba-configuration')||attempts>=80) clearInterval(timer);
  },100);
})();